export const widgetNameMap: { [key: string]: string } = {
  calorie: 'kcal',
  stand: 'standUp',
  intensity: 'strength',
  heartrate: 'heart',
  pressure: 'parssure',
  batteryLevel: 'power',
  cardBag: 'card',
  alarmClock: 'alarm',
  countdown: 'countDown',
  photogragh: 'photograph',
  aliPaymentCode: 'alipayPaymentCode',
  ECG: 'ecg'
};
